import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "../../../Pages/InputField/TableLayout";
import { FaEye, FaTrash, FaEdit } from "react-icons/fa";
import { Ban } from "lucide-react";
import { Button, Row, Col, Modal, Table, Form } from "react-bootstrap";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import Swal from "sweetalert2";
import PDFLayout from "../../Transactions/OrderSection/TaxInvoiceA4";
import { pdf } from "@react-pdf/renderer";
const RepairsTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [accounts, setAccounts] = useState([]);

  // Extract mobile from location state
  const { mobile } = location.state || {};
  const initialSearchValue = location.state?.mobile || "";

  useEffect(() => {
    if (mobile) {
      console.log("Selected Mobile from Dashboard:", mobile);
    }
  }, [mobile]);

  const handleAddReceipt = (invoiceData) => {
    navigate("/orderreceipts", {
      state: {
        from: "/orderstable",
        invoiceData: {
          ...invoiceData, // Spread all existing invoice data
          mobile: invoiceData.mobile, // Ensure mobile is included
        },
      },
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "SI",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Account",
        accessor: "account_name",
      },
      {
        Header: "Order No.",
        accessor: "order_number",
      },
      {
        Header: "Invoice No.",
        accessor: "invoice_number",
        Cell: ({ row }) => {
          const [invoiceNumbers, setInvoiceNumbers] = React.useState([]);
          const orderNumber = row.original.order_number;
          React.useEffect(() => {
            const fetchInvoices = async () => {
              try {
                const res = await fetch(
                  `${baseURL}/get-order-details/${orderNumber}`
                );
                const data = await res.json();
                setInvoiceNumbers(
                  (data.repeatedData || [])
                    .filter((d) => d.transaction_status==="Orders")
                    .map((d) => d.invoice_number)
                    .join(",")
                );
              } catch (err) {
                console.error("Error fetching invoice numbers:", err);
              }
            };

            if (orderNumber) fetchInvoices();
          }, [orderNumber]);
          return invoiceNumbers;
        },
      },

      {
        Header: "Total Amt",
        accessor: "net_amount",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: "URD Amt",
        accessor: "old_exchange_amt",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: "Scheme Amt",
        accessor: "scheme_amt",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: "SaleReturn Amt",
        accessor: "sale_return_amt",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: "Advance Amt",
        accessor: "advance_amt",
        Cell: ({ value }) => {
          if (!value) return 0;
          let arr = [];
          try {
            arr = JSON.parse(value);
          } catch (e) {
            return 0;
          }
          if (!Array.isArray(arr)) return 0;
          const total = arr.reduce(
            (sum, entry) => sum + Number(entry.amount || 0),
            0
          );
          return total.toFixed(2);
        },
      },
      {
        Header: "Discount",
        accessor: "disscount",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: "Fest Discount",
        accessor: "festival_discount",
        Cell: ({ value }) => value || 0,
      },
      // {
      //   Header: "Net Amt",
      //   accessor: "net_bill_amount",
      //   Cell: ({ value }) => value || 0,
      // },
      {
        Header: "Net Payable Amount",
        id: "net_payable_amount",
        Cell: ({ row }) => {
          const data = row.original;

          // Net amount
          const netAmount = Number(data.net_amount || 0);

          // Advance Amt (same parsing logic as before)
          let advanceTotal = 0;
          try {
            let arr = JSON.parse(data.advance_amt || "[]");
            if (Array.isArray(arr)) {
              advanceTotal = arr.reduce(
                (sum, entry) => sum + Number(entry.amount || 0),
                0
              );
            }
          } catch (e) {
            advanceTotal = 0;
          }

          // Other deductions
          const oldExchange = Number(data.old_exchange_amt || 0);
          const scheme = Number(data.scheme_amt || 0);
          const saleReturn = Number(data.sale_return_amt || 0);

          // Final Net Payable
          const netPayable =
            netAmount -
            oldExchange -
            scheme -
            saleReturn -
            advanceTotal -
            (Number(data.festival_discount) || 0);

          return Math.round(netPayable.toFixed(2));
        },
      },

      // {
      //   Header: "Paid Amt",
      //   accessor: "paid_amt",
      //   Cell: ({ row }) => {
      //     const paid_amt = Number(row.original.paid_amt) || 0;
      //     const receipts_amt = Number(row.original.receipts_amt) || 0;
      //     const totalPaid = (paid_amt + receipts_amt).toFixed(2);
      //     return totalPaid;
      //   },
      // },
      // {
      //   Header: "Bal Amt",
      //   accessor: "bal_amt",
      //   Cell: ({ row }) => {
      //     const bal_amt = Number(row.original.bal_amt) || 0;
      //     const bal_after_receipts =
      //       Number(row.original.bal_after_receipts) || 0;
      //     const receipts_amt = Number(row.original.receipts_amt) || 0;
      //     let finalBalance;
      //     if (bal_amt === receipts_amt) {
      //       finalBalance = bal_after_receipts || 0;
      //     } else {
      //       finalBalance = bal_after_receipts
      //         ? bal_after_receipts
      //         : bal_amt || 0;
      //     }
      //     return finalBalance.toFixed(2);
      //   },
      // },
      // {
      //   Header: 'Status',
      //   accessor: 'status',
      //   Cell: ({ row }) => (
      //     <select
      //       value={row.original.order_status}
      //       onChange={(e) => handleStatusChange(row.original.order_number, e.target.value)}
      //       style={{
      //         padding: '5px',
      //         border: '1px solid #ccc',
      //         borderRadius: '4px',
      //       }}
      //     >
      //       <option value="Pending">Pending</option>
      //       <option value="In Transit">In Transit</option>
      //       <option value="Delivered">Delivered</option>
      //     </select>
      //   ),
      // },
      // {
      //   Header: 'Order Status',
      //   accessor: 'order_status',
      //   Cell: ({ row }) => row.original.order_status || '-',
      // },
      // {
      //   Header: "Receipts",
      //   accessor: "receipts",
      //   Cell: ({ row }) => {
      //     const { net_bill_amount, paid_amt, receipts_amt, invoice } =
      //       row.original;

      //     const totalPaid = Number(paid_amt) + Number(receipts_amt);
      //     const netBill = Number(net_bill_amount);

      //     const isDisabled = netBill === totalPaid || invoice;

      //     return (
      //       <Button
      //         style={{
      //           backgroundColor: "#28a745",
      //           borderColor: "#28a745",
      //           fontSize: "0.800rem",
      //           padding: "0.10rem 0.5rem",
      //         }}
      //         onClick={() => handleAddReceipt(row.original)}
      //         disabled={isDisabled}
      //       >
      //         Add Receipt
      //       </Button>
      //     );
      //   },
      // },

      {
        Header: "PDF",
        accessor: "pdf",
        Cell: ({ row }) => {
          const orderNumber = row.original.order_number;

          if (!orderNumber) {
            return <span style={{ color: "#6c757d" }}>N/A</span>;
          }

          const pdfHref = `/pdf/order/${encodeURIComponent(orderNumber)}`;

          return (
            <a
              href={pdfHref}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                cursor: "pointer",
                color: "#0D6EFD",
              }}
            >
              📝 View
            </a>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "actions",
        Cell: ({ row }) => {
          const isEditDisabled =
            row.original.invoice === "Converted" || row.original.allRefunded;

          return (
            <div>
              <button
                onClick={() => handleViewDetails(row.original.order_number)}
                // disabled={row.original.allRefunded}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
              >
                <Ban size={16} color="red" />
              </button>

              <FaEdit
                style={{
                  cursor: isEditDisabled ? "not-allowed" : "pointer", // Change cursor style when disabled
                  marginLeft: "10px",
                  color: isEditDisabled ? "gray" : "blue",
                }}
                onClick={() => {
                  if (!isEditDisabled) {
                    // Only allow editing if not disabled
                    handleEdit(
                      row.original.order_number,
                      row.original.mobile,
                      // row.original.old_exchange_amt,
                      // row.original.scheme_amt,
                      row.original.cash_amount,
                      row.original.card_amt,
                      row.original.chq_amt,
                      row.original.online_amt,
                      row.original.advance_amt
                    );
                  }
                }}
              />

              {/* <FaTrash
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                  color: "red",
                }}
                onClick={() => handleDelete(row.original.order_number)}
              /> */}
            </div>
          );
        },
      },
      // {
      //   Header: "Invoice",
      //   accessor: "convert",
      //   Cell: ({ row }) => {
      //     const isDisabled = row.original.invoice;
      //     return (
      //       <Button
      //         style={{
      //           backgroundColor: isDisabled ? "#ccc" : "#28a745",
      //           borderColor: isDisabled ? "#ccc" : "#28a745",
      //           // backgroundColor: "#28a745",
      //           // borderColor: "#28a745",
      //           fontSize: "0.800rem",
      //           padding: "0.10rem 0.5rem",
      //           cursor: isDisabled ? "not-allowed" : "pointer",
      //           // cursor: "pointer",
      //         }}
      //         onClick={() => handleConvert(row.original)}
      //         disabled={isDisabled}
      //       >
      //         Generate
      //       </Button>
      //     );
      //   },
      // },
      {
        Header: "Vendor",
        accessor: "assigned_vendor",
        Cell: ({ row }) => {
          const navigate = useNavigate();
          const orderNumber = row.original.order_number;
          const [buttonLabel, setButtonLabel] = React.useState("Assign");
          const [buttonColor, setButtonColor] = React.useState("#28a745");
          const [isDisabled, setIsDisabled] = React.useState(false);

          React.useEffect(() => {
            const fetchStatus = async () => {
              try {
                const response = await axios.get(
                  `${baseURL}/get-order-details/${orderNumber}`
                );
                let repeatedData = response.data.repeatedData || [];
                repeatedData = repeatedData.filter(
                  (item) => item.invoice_number === null
                );
                const noVendorAssigned = repeatedData.every(
                  (item) => item.vendor_id === null
                );

                const allAssigned =
                  repeatedData.length > 0 &&
                  repeatedData.every((item) => item.vendor_id !== null);

                const orderDateUTC = new Date(response.data.uniqueData?.date);
                const orderDateIST = new Date(
                  orderDateUTC.getTime() + 5.5 * 60 * 60 * 1000
                );

                const todayIST = new Date();
                const todayOffset = todayIST.getTime() + 5.5 * 60 * 60 * 1000;
                const todayInIST = new Date(todayOffset);

                const isOrderCreatedToday =
                  orderDateIST.getDate() === todayInIST.getDate() &&
                  orderDateIST.getMonth() === todayInIST.getMonth() &&
                  orderDateIST.getFullYear() === todayInIST.getFullYear();

                if (repeatedData.every((item) => item.refund_amount !== null)) {
                  setIsDisabled(true);
                  setButtonLabel("Assign");
                  setButtonColor("#28a745");
                } else if (
                  repeatedData.length > 0 &&
                  repeatedData.every((item) => item.is_sales_generated === 1)
                ) {
                  setButtonLabel("Generate Sales");
                  setButtonColor("#007bff");
                  setIsDisabled(true);
                } else if (
                  repeatedData.length > 0 &&
                  repeatedData.every(
                    (item) => item.submission_status === "selected"
                  )
                ) {
                  setButtonLabel("Generate Sales");
                  setButtonColor("#007bff");
                  setIsDisabled(false);
                } else if (allAssigned) {
                  setButtonLabel("In Progress");
                  setButtonColor("#a36e29");
                  setIsDisabled(false);
                } else {
                  setButtonLabel("Assign");
                  setButtonColor("#28a745");
                  setIsDisabled(false);
                }
              } catch (error) {
                console.error("Error fetching order details:", error);
              }
            };
            fetchStatus();
          }, [orderNumber]);

          return (
            <Button
              style={{
                backgroundColor: buttonColor,
                borderColor: buttonColor,
                fontSize: "0.800rem",
                padding: "0.10rem 0.5rem",
                opacity: isDisabled ? 0.6 : 1,
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
              disabled={isDisabled}
              onClick={() => {
                if (!isDisabled) {
                  navigate(`/orderstable/${orderNumber}`);
                }
              }}
            >
              {buttonLabel}
            </Button>
          );
        },
      },
      {
        Header: "Cancellation Status",
        accessor: "cancellation_status",
        Cell: ({ row }) => {
          const [cancellationInfo, setCancellationInfo] = React.useState({
            status: "Active",
            refundAmount: 0,
            totalRefunded: 0,
          });

          React.useEffect(() => {
            const fetchCancellationStatus = async () => {
              try {
                const response = await axios.get(
                  `${baseURL}/get-order-details/${row.original.order_number}`
                );
                const repeatedData = response.data.repeatedData || [];
                const orderItems = repeatedData.filter(
                  (item) => item.transaction_status === "Orders"
                );

                if (orderItems.length === 0) {
                  setCancellationInfo({
                    status: "Active",
                    refundAmount: 0,
                    totalRefunded: 0,
                  });
                  return;
                }

                const totalItems = orderItems.length;
                const cancelledItems = orderItems.filter(
                  (item) =>
                    item.refund_amount !== null &&
                    item.refund_amount !== undefined
                );

                let totalRefunded = 0;
                cancelledItems.forEach((item) => {
                  try {
                    if (item.refund_amount) {
                      const refunds = JSON.parse(item.refund_amount);
                      if (Array.isArray(refunds)) {
                        const itemRefundTotal = refunds.reduce(
                          (sum, refund) =>
                            sum + (parseFloat(refund.amount) || 0),
                          0
                        );
                        totalRefunded += itemRefundTotal;
                      }
                    }
                  } catch (e) {
                    console.warn(
                      "Error parsing refund_amount:",
                      item.refund_amount
                    );
                  }
                });

                let status = "Active";
                if (cancelledItems.length === totalItems) {
                  status = "Cancelled";
                } else if (cancelledItems.length > 0) {
                  status = "Partially Cancelled";
                }

                setCancellationInfo({
                  status,
                  refundAmount: totalRefunded,
                  totalRefunded,
                });
              } catch (error) {
                console.error("Error fetching cancellation status:", error);
                setCancellationInfo({
                  status: "Active",
                  refundAmount: 0,
                  totalRefunded: 0,
                });
              }
            };

            fetchCancellationStatus();
          }, [row.original.order_number]);

          const getStatusColor = (status) => {
            switch (status) {
              case "Cancelled":
                return { color: "#dc3545", fontWeight: "bold" };
              case "Partially Cancelled":
                return { color: "#fd7e14", fontWeight: "bold" };
              default:
                return { color: "#28a745", fontWeight: "bold" };
            }
          };

          return (
            <div style={{ fontSize: "0.8rem" }}>
              <div style={getStatusColor(cancellationInfo.status)}>
                {cancellationInfo.status}
              </div>
              {cancellationInfo.totalRefunded > 0 && (
                <div style={{ color: "#6c757d", fontSize: "0.7rem" }}>
                  Refund: ₹{cancellationInfo.totalRefunded.toFixed(2)}
                </div>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const [repairDetails, setRepairDetails] = useState({});

  const handleConvert = async (order) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to convert this sale order to an invoice?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, convert it!",
      cancelButtonText: "No, cancel",
    });

    // If the user confirms, proceed with the conversion
    if (result.isConfirmed) {
      try {
        const response = await axios.post(`${baseURL}/convert-order`, {
          order_number: order.order_number,
        });

        if (response.data.success) {
          Swal.fire(
            "Converted!",
            "Order has been converted to invoice.",
            "success"
          ); // Success message

          // Fetch the invoice number after conversion
          const invoiceResponse = await axios.get(
            `${baseURL}/invoice/${order.order_number}`
          );
          if (invoiceResponse.data.success) {
            const invoiceData = invoiceResponse.data.data;
            const invoiceNumber = invoiceData.invoice_number;

            console.log("Order details=", invoiceData);

            setRepairDetails(invoiceData);

            // Generate PDF Blob
            const pdfDoc = <PDFLayout repairDetails={invoiceData} />;

            const pdfBlob = await pdf(pdfDoc).toBlob();
            await handleSavePDFToServer(pdfBlob, invoiceNumber);

            // Create a download link and trigger it
            const link = document.createElement("a");
            link.href = URL.createObjectURL(pdfBlob);
            link.download = `${invoiceNumber}.pdf`;
            link.click();

            // Clean up
            URL.revokeObjectURL(link.href);
          }
        }

        // Additional logic to update state or re-fetch data
        fetchRepairs(); // Refresh the list of repairs
      } catch (error) {
        console.error("Error converting order:", error);
        Swal.fire(
          "Error",
          "Unable to convert the order. Please try again.",
          "error"
        ); // Error message
      }
    } else {
      Swal.fire("Cancelled", "Order conversion has been cancelled.", "info"); // Cancellation message
    }
  };

  const handleSavePDFToServer = async (pdfBlob, invoiceNumber) => {
    const formData = new FormData();
    formData.append("invoice", pdfBlob, `${invoiceNumber}.pdf`);

    try {
      const response = await fetch(`${baseURL}/upload-invoice`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to upload invoice");
      }

      console.log(`Invoice ${invoiceNumber} saved on server`);
    } catch (error) {
      console.error("Error uploading invoice:", error);
    }
  };

  const handleStatusChange = async (orderNumber, newStatus) => {
    try {
      console.log("Sending Request with:", {
        order_number: orderNumber,
        order_status: newStatus,
      }); // Debugging

      // Make the PUT request to update the status in the backend
      const response = await axios.put(`${baseURL}/update-order-status`, {
        order_number: orderNumber,
        order_status: newStatus,
      });

      if (response.status === 200) {
        // Update the local state with the new status
        setData((prevData) =>
          prevData.map((item) =>
            item.order_number === orderNumber
              ? { ...item, order_status: newStatus }
              : item
          )
        );

        Swal.fire("Success", "Order status updated successfully.", "success");
      } else {
        Swal.fire("Error", "Failed to update the order status.", "error");
      }
    } catch (error) {
      console.error(
        "Error updating order status:",
        error.response?.data || error.message
      );

      Swal.fire(
        "Error",
        "An error occurred while updating the order status.",
        "error"
      );
    }
  };

  // const fetchRepairs = async () => {
  //   try {
  //     const response = await axios.get(`${baseURL}/get-unique-order-details`);
  //     console.log("Full response data: ", response.data);
  //     const filteredData = response.data.filter(
  //       (item) =>
  //         item.transaction_status === "Orders" ||
  //         item.transaction_status === "ConvertedInvoice"
  //     );
  //     console.log("Filtered Orders: ", filteredData);
  //     setData(filteredData);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching repair details:", error);
  //     setLoading(false);
  //   }
  // };
  const fetchRepairs = async () => {
    try {
      const response = await axios.get(`${baseURL}/get-unique-order-details`);
      console.log("Full response data: ", response.data);

      // Filter top-level orders first
      const filteredOrders = response.data.filter(
        (item) =>
          item.transaction_status === "Orders" ||
          item.transaction_status === "ConvertedInvoice"
      );

      // For each order, fetch its details and compute allRefunded
      const enrichedOrders = await Promise.all(
        filteredOrders.map(async (order) => {
          try {
            const detailsRes = await axios.get(
              `${baseURL}/get-order-details/${order.order_number}`
            );

            const filteredData = detailsRes.data.repeatedData.filter(
              (item) =>
                item.transaction_status === "Orders" &&
                item.invoice_number === null
            );

            const allRefunded = filteredData.every(
              (item) =>
                item.refund_amount !== null && item.refund_amount !== undefined
            );

            return {
              ...order,
              allRefunded,
              net_amount: filteredData[0].net_amount,
            };
          } catch (err) {
            console.error(
              `Error fetching details for order ${order.order_number}:`,
              err
            );
            return { ...order, allRefunded: false };
          }
        })
      );

      console.log("Enriched Orders: ", enrichedOrders);
      setData(enrichedOrders);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching repair details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepairs();
    handleViewDetails();
  }, []);

  useEffect(() => {
    const fetchEmployeeCompensationAccounts = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/get-employee-compensation-accounts`
        );
        if (Array.isArray(response.data)) {
          setAccounts(response.data);
        } else {
          console.error("Expected an array but got:", response.data);
        }
      } catch (error) {
        console.error("Error fetching accounts:", error);
      }
    };

    fetchEmployeeCompensationAccounts();
  }, []);

  const handleViewDetails = async (order_number) => {
    try {
      const response = await axios.get(
        `${baseURL}/get-order-details/${order_number}`
      );
      console.log("Fetched order details: ", response.data); // Log full response data

      // Filter repeatedData to include only items where transaction_status is "Orders"
      const filteredData = response.data.repeatedData.filter(
        (item) => item.transaction_status === "Orders"
      );

      // Check if any item in repeatedData has invoice === "Converted"
      const isInvoiceConverted = filteredData.some(
        (item) => item.invoice === "Converted"
      );
      console.log("isInvoiceConverted=", isInvoiceConverted);
      // Set state with filtered repeatedData and invoice status
      setOrderDetails({
        ...response.data,
        repeatedData: filteredData,
        isInvoiceConverted,
      });

      setShowModal(true);
    } catch (error) {
      console.error("Error fetching repair details:", error);
    }
  };

  //no need of this
  // const handleWorkerAssignment = async (order_number, code, worker_name) => {
  //   try {
  //     // Find the selected account and get its account_id
  //     const selectedAccount = accounts.find(account => account.account_name === worker_name);
  //     const account_id = selectedAccount?.account_id;

  //     if (!account_id) {
  //       alert('Account ID is not found for the selected worker.');
  //       return;
  //     }

  //     const response = await axios.post(`${baseURL}/assign-worker`, {
  //       order_number,
  //       code,
  //       worker_name,
  //       account_id, // Pass the account_id to the backend
  //     });

  //     if (response.data.success) {
  //       setOrderDetails(prev => ({
  //         ...prev,
  //         repeatedData: prev.repeatedData.map(product => {
  //           if (product.code === code) {
  //             return {
  //               ...product,
  //               assigning: 'assigned',
  //               account_name: worker_name,
  //               account_id
  //             };
  //           }
  //           return product;
  //         })
  //       }));

  //       // Show success message
  //       alert('Worker assigned successfully!');
  //     }
  //     fetchRepairs();
  //     handleViewDetails();
  //   } catch (error) {
  //     console.error('Error assigning worker:', error);
  //     alert('Failed to assign worker. Please try again.');
  //   }
  // };

  const handleEdit = async (
    order_number,
    mobile,
    cash_amount,
    card_amt,
    chq_amt,
    online_amt,
    advance_amt
  ) => {
    console.log("Advance Amt=", advance_amt);
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, go ahead!",
      cancelButtonText: "No, cancel",
    });

    if (result.isConfirmed) {
      try {
        // Fetch repair details
        const response = await axios.get(
          `${baseURL}/get-order-details/${order_number}`
        );
        let details = response.data;
        details.repeatedData = (details.repeatedData || []).filter(
          (item) => item.transaction_status === "Orders"
        );

        // Fetch old items details
        const oldItemsResponse = await axios.get(
          `${baseURL}/get/olditems/${order_number}`
        );
        const oldItemsDetails = oldItemsResponse.data;

        // Verify if the API returned data
        if (!details || !details.repeatedData) {
          console.error("No repeatedData found in response:", details);
          Swal.fire(
            "Error",
            "No repair details found for the provided order number.",
            "error"
          );
          return;
        }
        const isVendorAssigned = details.repeatedData.some(
          (item) => item.vendor_id !== null && item.vendor_id !== undefined
        );

        // Retrieve existing repair details from localStorage or set to an empty array if not available
        const existingDetails =
          JSON.parse(localStorage.getItem("orderDetails")) || [];

        // Retrieve existing old items details from localStorage or set to an empty array if not available
        const existingOldItems =
          JSON.parse(localStorage.getItem("oldTableData")) || [];

        // Get today's date in yyyy-mm-dd format
        const today = new Date().toISOString().split("T")[0];

        // Update repeatedData with today's date
        const formattedDetails = details.repeatedData.map((item) => ({
          ...item,
          date: today,
          order_number, // Ensure the order_number is explicitly included
        }));

        // Format old items details with today's date
        const formattedOldItems = oldItemsDetails.map((item) => ({
          ...item,
          date: today,
          order_number, // Ensure invoice_number is included
        }));

        // Combine existing details with the new ones
        const updatedDetails = [...existingDetails, ...formattedDetails];

        // Combine existing old items with new ones
        const updatedOldItems = [...existingOldItems, ...formattedOldItems];

        // Save updated details back to localStorage
        localStorage.setItem("orderDetails", JSON.stringify(updatedDetails));
        localStorage.setItem("oldTableData", JSON.stringify(updatedOldItems));

        console.log(
          "Updated repair details added to localStorage:",
          updatedDetails
        );

        // Navigate to the sales page with state
        navigate("/orders", {
          state: {
            order_number,
            mobile,
            // old_exchange_amt,
            // scheme_amt,
            cash_amount,
            card_amt,
            chq_amt,
            online_amt,
            orderDetails: details,
            advance_amt,
            vendorAssigned: isVendorAssigned,
          },
        });

        // Call handleDelete without confirmation
        // await handleDelete(order_number, true, true);
      } catch (error) {
        console.error("Error fetching repair details:", error);
        Swal.fire(
          "Error",
          "Unable to fetch repair details. Please try again.",
          "error"
        );
      }
    } else {
      Swal.fire("Cancelled", "Edit operation was cancelled.", "info");
    }
  };

  const handleDelete = async (
    orderNumber,
    skipConfirmation = false,
    skipMessage = false
  ) => {
    if (skipConfirmation) {
      try {
        const response = await axios.delete(
          `${baseURL}/order-details/${orderNumber}`,
          { params: { skipMessage: skipMessage ? "true" : "false" } } // Pass skipMessage as query parameter
        );

        if (response.status === 200 || response.status === 204) {
          if (!skipMessage) {
            Swal.fire("Deleted!", response.data.message, "success");
          }
          setData((prevData) =>
            prevData.filter((item) => item.order_number !== orderNumber)
          );
        }
      } catch (error) {
        console.error("Error deleting repair details:", error);
        Swal.fire(
          "Error!",
          "Failed to delete repair details. Please try again.",
          "error"
        );
      }
    } else {
      // Show the confirmation alert
      Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to delete order ${orderNumber}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(
              `${baseURL}/order-details/${orderNumber}`
            );
            if (response.status === 200) {
              Swal.fire("Deleted!", response.data.message, "success");
              setData((prevData) =>
                prevData.filter((item) => item.order_number !== orderNumber)
              );
            }
          } catch (error) {
            console.error("Error deleting repair details:", error);
            Swal.fire(
              "Error!",
              "Failed to delete repair details. Please try again.",
              "error"
            );
          }
        }
      });
    }
  };
  const parseAdvanceTotal = (advance) => {
    if (!advance) return 0;
    let arr = [];
    try {
      arr = typeof advance === "string" ? JSON.parse(advance) : advance;
    } catch (e) {
      return 0;
    }
    if (!Array.isArray(arr)) return 0;
    const total = arr.reduce(
      (sum, entry) => sum + Number(entry.amount || 0),
      0
    );

    return total;
  };
  const handleConfirmCancel = async (selectedProducts, refunds) => {
    const totalAdvance =
      parseAdvanceTotal(orderDetails.repeatedData?.[0]?.advance_amt) || 0;

    const alreadyRefundedAmount = orderDetails.repeatedData.reduce(
      (sum, item) => {
        try {
          if (!item.refund_amount) return sum;
          const parsed = JSON.parse(item.refund_amount);
          if (!Array.isArray(parsed)) return sum;
          return (
            sum +
            parsed.reduce(
              (innerSum, r) => innerSum + (parseFloat(r.amount) || 0),
              0
            )
          );
        } catch (err) {
          console.warn(
            "Failed to parse refund_amount:",
            item.refund_amount,
            err
          );
          return sum;
        }
      },
      0
    );

    const totalRefundNow = refunds.reduce(
      (sum, r) => sum + Number(r.amount || 0),
      0
    );

    const cancellableProducts = orderDetails.repeatedData.filter(
      (item) => item.refund_amount === null
    );
    const selectedCancellableCount = selectedProducts.filter((id) =>
      cancellableProducts.some((item) => item.id === id)
    ).length;
    const allRefundableCancelled =
      selectedCancellableCount === cancellableProducts.length;

    const remainingAmount = totalAdvance - alreadyRefundedAmount;

    if (allRefundableCancelled) {
      if (totalRefundNow !== remainingAmount) {
        alert(
          `Since you are cancelling all products, the refund must be exactly ${remainingAmount.toFixed(
            2
          )}. You entered ${totalRefundNow.toFixed(2)}.`
        );
        return;
      }
    } else {
      if (totalRefundNow + alreadyRefundedAmount > totalAdvance) {
        alert(
          `Total refund cannot exceed advance amount (${totalAdvance.toFixed(
            2
          )}). You have already refunded ${alreadyRefundedAmount.toFixed(2)}.`
        );
        return;
      }
    }
    try {
      if (!selectedProducts.length) {
        alert("No products selected");
        return;
      }
      const payload = selectedProducts.map((productId) => ({
        product_id: productId,
        refunds: refunds,
      }));
      console.log(payload, "payload here");

      const response = await axios.post(`${baseURL}/cancel-product`, {
        refunds: payload,
      });

      if (response.data.success) {
        alert("Products cancelled successfully");
        setShowRefundModal(false);
        setSelectedProducts([]);
        setShowModal(false);
        setRefunds([{ amount: "", method: "" }]);
      } else {
        alert("Failed to cancel products");
      }
    } catch (err) {
      console.error(err);
      alert("Error while cancelling products");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setOrderDetails(null);
    setSelectedProducts([]);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };
  const [selectedProducts, setSelectedProducts] = useState([]);

  const toggleProductSelection = (productId) => {
    setSelectedProducts((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };
  const [refunds, setRefunds] = useState([{ amount: "", method: "" }]);
  const [showRefundModal, setShowRefundModal] = useState(false);

  return (
    <div className="main-container">
      <div className="payments-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Orders</h3>
            <Button
              className="create_but"
              onClick={() => window.open("/orders", "_blank")}
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
            >
              + Create
            </Button>
          </Col>
        </Row>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <DataTable
            columns={columns}
            data={[...data].reverse()}
            initialSearchValue={initialSearchValue}
          />
        )}
      </div>

      {/* Modal to display repair details */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="xl"
        className="m-auto"
      >
        <Modal.Header closeButton>
          <Modal.Title>Orders Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "13px" }}>
          {orderDetails && (
            <>
              <h5>Customer Info</h5>
              <Table bordered hover responsive>
                <tbody>
                  {/* <tr>
                    <td>Customer ID</td>
                    <td>{orderDetails.uniqueData.customer_id}</td>
                  </tr> */}
                  <tr>
                    <td style={{ color: '#6B451E', backgroundColor: '#f4f5f7', fontWeight: '600' }}>Mobile</td>
                    <td>{orderDetails.uniqueData.mobile}</td>
                  </tr>
                  <tr>
                    <td style={{ color: '#6B451E', backgroundColor: '#f4f5f7', fontWeight: '600' }}>Account Name</td>
                    <td>{orderDetails.uniqueData.account_name}</td>
                  </tr>
                  <tr>
                    <td style={{ color: '#6B451E', backgroundColor: '#f4f5f7', fontWeight: '600' }}>Email</td>
                    <td>{orderDetails.uniqueData.email}</td>
                  </tr>
                  <tr>
                    <td style={{ color: '#6B451E', backgroundColor: '#f4f5f7', fontWeight: '600' }}>Address</td>
                    <td>{orderDetails.uniqueData.address1}</td>
                  </tr>
                  <tr>
                    <td style={{ color: '#6B451E', backgroundColor: '#f4f5f7', fontWeight: '600' }}>Invoice Number</td>
                    <td>{orderDetails.uniqueData.order_number}</td>
                  </tr>
                  <tr>
                    <td style={{ color: '#6B451E', backgroundColor: '#f4f5f7', fontWeight: '600' }}>Total Amount</td>
                    <td>{orderDetails.uniqueData.net_amount}</td>
                  </tr>
                  <tr>
                    <td style={{ color: '#6B451E', backgroundColor: '#f4f5f7', fontWeight: '600' }}>Advance Amount</td>
                    <td>
                      {parseAdvanceTotal(
                        orderDetails.repeatedData?.[0]?.advance_amt
                      ).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </Table>

              <h5>Products</h5>
              <div className="table-responsive">
                <Table bordered hover responsive>
                  <thead style={{ whiteSpace: "nowrap", fontSize: "13px" }}>
                    <tr>
                      <th>
                        {/* <input
                          type="checkbox"
                          checked={
                            orderDetails.repeatedData.length > 0 &&
                            selectedProducts.length ===
                              orderDetails.repeatedData.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedProducts(
                                orderDetails.repeatedData.map((p) => p.id)
                              );
                            } else {
                              setSelectedProducts([]);
                            }
                          }}
                        /> */}
                        <input
                          type="checkbox"
                          checked={
                            orderDetails.repeatedData.filter(
                              (p) => p.refund_amount == null
                            ).length > 0 &&
                            selectedProducts.length ===
                              orderDetails.repeatedData.filter(
                                (p) => p.refund_amount == null
                              ).length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedProducts(
                                orderDetails.repeatedData
                                  .filter((p) => p.refund_amount == null)
                                  .map((p) => p.id)
                              );
                            } else {
                              setSelectedProducts([]);
                            }
                          }}
                        />
                      </th>
                      <th style={{ color: '#6B451E' }}>Bar Code</th>
                      <th style={{ color: '#6B451E' }}>Product Name</th>
                      <th style={{ color: '#6B451E' }}>Metal Type</th>
                      <th style={{ color: '#6B451E' }}>Purity</th>
                      <th style={{ color: '#6B451E' }}>Gross Wt</th>
                      <th style={{ color: '#6B451E' }}>Stone Wt</th>
                      <th style={{ color: '#6B451E' }}>W.Wt</th>
                      <th style={{ color: '#6B451E' }}>Total Wt</th>
                      <th style={{ color: '#6B451E' }}>Size</th>
                      <th style={{ color: '#6B451E' }}>MC</th>
                      <th style={{ color: '#6B451E' }}>Rate</th>
                      <th style={{ color: '#6B451E' }}>Tax Amt</th>
                      <th style={{ color: '#6B451E' }}>Total Price</th>
                      <th style={{ color: '#6B451E' }}>Status</th>
                      <th style={{ color: '#6B451E' }}>Assigning</th>
                      <th style={{ color: '#6B451E' }}>Vendor Name</th>
                    </tr>
                  </thead>
                  <tbody style={{ whiteSpace: "nowrap", fontSize: "13px" }}>
                    {orderDetails.repeatedData.map((product, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedProducts.includes(product.id)}
                            onChange={() => toggleProductSelection(product.id)}
                            disabled={product.refund_amount != null || product.invoice_number!=null}
                          />
                        </td>
                        <td>{product.code}</td>
                        <td>{product.product_name}</td>
                        <td>{product.metal_type}</td>
                        <td>{product.purity}</td>
                        <td>{product.gross_weight}</td>
                        <td>{product.stone_weight}</td>
                        <td>{product.wastage_weight}</td>
                        <td>{product.total_weight_av}</td>
                        <td>{product.size}</td>
                        <td>{product.making_charges}</td>
                        <td>{product.rate}</td>
                        <td>{product.tax_amt}</td>
                        <td>{product.total_price}</td>
                        <td>
                          {product.refund_amount != null ? (
                            <span style={{ color: "red", fontWeight: "bold" }}>
                              Cancelled
                            </span>
                          ) : product.invoice_number?(
                            <span
                              style={{ color: "green", fontWeight: "bold" }}
                            >
                              Invoice Generated
                            </span>
                          ):(
                            <span
                              style={{ color: "green", fontWeight: "bold" }}
                            >
                              In Progress
                            </span>
                          )}
                        </td>

                        <td>
                          {!product.vendor_id ? (
                            <span>Pending</span>
                          ) : (
                            <span>Assigned</span>
                          )}
                        </td>
                        <td>{product.vendor_name || "Not Assigned"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {selectedProducts.length > 0 && (
            <div>
              <Button variant="danger" onClick={() => setShowRefundModal(true)}>
                Cancel Selected ({selectedProducts.length})
              </Button>
            </div>
          )}
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {showRefundModal && (
        <Modal show onHide={() => setShowRefundModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Cancel Products</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {orderDetails && (
              <>
                {(() => {
                  const cancellableProducts = orderDetails.repeatedData.filter(
                    (item) => item.refund_amount === null
                  );
                  const selectedCancellableCount = selectedProducts.filter(
                    (id) => cancellableProducts.some((item) => item.id === id)
                  ).length;
                  const allRefundableCancelled =
                    selectedCancellableCount === cancellableProducts.length;

                  const totalAdvance =
                    parseAdvanceTotal(
                      orderDetails.repeatedData?.[0]?.advance_amt
                    ) || 0;
                  const refundableAmount = allRefundableCancelled
                    ? totalAdvance
                    : totalAdvance;

                  const alreadyRefundedAmount =
                    orderDetails.repeatedData.reduce((sum, item) => {
                      try {
                        if (!item.refund_amount) return sum;
                        const parsed = JSON.parse(item.refund_amount);
                        if (!Array.isArray(parsed)) return sum;
                        return (
                          sum +
                          parsed.reduce(
                            (innerSum, r) =>
                              innerSum + (parseFloat(r.amount) || 0),
                            0
                          )
                        );
                      } catch (err) {
                        console.warn(
                          "Failed to parse refund_amount:",
                          item.refund_amount,
                          err
                        );
                        return sum;
                      }
                    }, 0);

                  console.log("Total already refunded:", alreadyRefundedAmount);

                  const availableAmount = totalAdvance - alreadyRefundedAmount;

                  return (
                    <>
                      <p>
                        You are cancelling <b>{selectedCancellableCount}</b>{" "}
                        {selectedCancellableCount === 1
                          ? "product"
                          : "products"}
                        .
                      </p>
                      <p>
                        Advance Paid: <b>{totalAdvance.toFixed(2)}</b>
                      </p>
                      {/* {allRefundableCancelled && ( */}
                      <p>
                        Available Amount after refund:{" "}
                        <b>{availableAmount.toFixed(2)}</b>
                      </p>
                      {/* )} */}

                      {refunds.map((refund, idx) => (
                        <div key={idx} className="d-flex mb-2 gap-2">
                          <Form.Control
                            type="number"
                            placeholder="Amount"
                            value={refund.amount}
                            onChange={(e) => {
                              const newRefunds = [...refunds];
                              newRefunds[idx].amount = e.target.value;
                              setRefunds(newRefunds);
                            }}
                          />
                          <Form.Select
                            value={refund.method}
                            onChange={(e) => {
                              const newRefunds = [...refunds];
                              newRefunds[idx].method = e.target.value;
                              setRefunds(newRefunds);
                            }}
                          >
                            <option value="">Select Method</option>
                            <option value="Cash">Cash</option>
                            <option value="Online">Online</option>
                            <option value="Bank Transfer">Bank Transfer</option>
                            <option value="Cheque">Cheque</option>
                            <option value="Card">Card</option>
                          </Form.Select>
                        </div>
                      ))}

                      <Button
                        size="sm"
                        onClick={() =>
                          setRefunds([...refunds, { amount: "", method: "" }])
                        }
                      >
                        + Add Refund
                      </Button>
                    </>
                  );
                })()}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowRefundModal(false)}
            >
              Close
            </Button>
            <Button
              variant="danger"
              onClick={() => handleConfirmCancel(selectedProducts, refunds)}
            >
              Confirm Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default RepairsTable;
